export const acceptCommunityRequestRules = (inputs) => {
    return {
        id: {
            errors: [],
            value: inputs.id,
            isValid: null,
            validations: {
                required: {
                    error: "Community Request Id is required",
                    trim: true
                },
                maxLength: {
                    value: 100,
                    error: "Community Request Id cannot be more than 100 characters"
                },
                // minLength: {
                //     value: 5,
                //     error: "Community Request Id"
                // }
            }
        },
        reason: {
            errors: [],
            value: inputs.reason,
            isValid: null,
            validations: {
                required: {
                    error: "Reason is required",
                    trim: true
                },
                maxLength: {
                    value: 300,
                    error: "Reason cannot be more than 300 characters"
                },
                // minLength: {
                //     value: 5,
                //     error: "Reason cannot be less than 5 characters"
                // }
            }
        },
        description: {
            errors: [],
            value: inputs.description,
            isValid: null,
            validations: {
                maxLength: {
                    value: 300,
                    error: "Description cannot be more than 300 characters"
                }
            }
        },
        title: {
            errors: [],
            value: inputs.title,
            isValid: null,
            validations: {
                required: {
                    error: "Title is required",
                    trim: true
                },
                maxLength: {
                    value: 300,
                    error: "Title cannot be more than 300 characters"
                }
            }
        },
    }
}